module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-error-page"
  }, [(!_vm.$store.state.is_auth) ? [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  }), _vm._v(" "), _c('br'), _c('br'), _c('br')] : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('p', [_vm._v("К сожалению, запрашиваемая страница не найдена.")]), _vm._v(" "), (_vm.$store.state.is_auth) ? _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Вы можете вернуться на главную страницу.")]) : _vm._e()], 1)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-404"
  }, [_vm._v("4"), _c('div', {
    staticClass: "bird-map"
  }), _vm._v("4")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83f80650"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notFound.vue
// module id = 279
// module chunks = 0